import 'vuetify/styles'
import {createVuetify} from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import * as directives from 'vuetify/directives'
import * as vComponents from 'vuetify/components'
import {VDataTable, VDataTableServer, VDataTableVirtual,} from "vuetify/components/VDataTable";

export default createVuetify({
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#551A8B', // Custom primary color
                    // Darker than the Vuetify defaults so white text on them passes 4.5:1.
                    warning: '#B45309',
                    success: '#2E7D32',
                },
            }
        },
    },
    components: {
        ...vComponents,
        // Vuetify 3 lab components registration
        VDataTable,
        VDataTableServer,
        VDataTableVirtual,
    },
    directives
})
